import base from "@/store/utils/api-route/base";

const transaksi = {
  reguler: {
    getList: `${base.meta}list_permintaan_penghapusan_transaksi`,
    getDetail: `${base.meta}detail_permintaan_penghapusan_transaksi`,
    approved: `${base.pembatalan}setujui_permintaan_hapus_transaksi_v2`,
    decline: `${base.pembatalan}tolak_permintaan_hapus_transaksi`,
    export: {
      job: `${base.export}job`,
      track: `${base.export}track_redis_job`,
      delete: {
        cluster: `${base.export}delete_cluster_redis_job`,
        master: `${base.export}delete_master_redis_job`,
      },
    },
  },
  snapClean: {
    getList: `${base.meta}list_permintaan_hapus_snapclean`,
    getDetail: `${base.meta}detail_permintaan_hapus_snapclean`,
    approved: `${base.pembatalan}setujui_hapus_transaksi_snapclean`,
    decline: `${base.pembatalan}tolak_hapus_transaksi_snapclean`,
    export: {
      job: `${base.export}job`,
      track: `${base.export}track_redis_job`,
      delete: {
        cluster: `${base.export}delete_cluster_redis_job`,
        master: `${base.export}delete_master_redis_job`,
      },
    },
  },
  deposit: {
    getList: `${base.meta}list_permintaan_refund_deposit`,
    getDetail: `${base.meta}detail_permintaan_refund_deposit`,
    approved: `${base.pembatalan}setujui_permintaan_hapus_deposit`,
    decline: `${base.pembatalan}tolak_permintaan_hapus_deposit`,
    export: {
      job: `${base.export}job`,
      track: `${base.export}track_redis_job`,
      delete: {
        cluster: `${base.export}delete_cluster_redis_job`,
        master: `${base.export}delete_master_redis_job`,
      },
    },
  },
  ePayment: {
    getList: `${base.meta}list_permintaan_refund_epayment`,
    getDetail: `${base.meta}detail_permintaan_refund_epayment`,
    approved: `${base.pembatalan}setujui_permintaan_hapus_epayment`,
    decline: `${base.pembatalan}tolak_permintaan_hapus_epayment`,
    export: {
      job: `${base.export}job`,
      track: `${base.export}track_redis_job`,
      delete: {
        cluster: `${base.export}delete_cluster_redis_job`,
        master: `${base.export}delete_master_redis_job`,
      },
    },
  },
};

export default transaksi;
